/**
 * /eric/agent-telemetry — operator agent telemetry panel (T-083, AI-14,
 * TECH-22).
 *
 * Route config only. Component lives in eric.agent-telemetry.lazy.tsx
 * (code-split). No loader, beforeLoad, or validateSearch.
 */

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/eric/agent-telemetry')({});
